import { pathOr } from 'ramda';

import { IApplicationState } from '../../types/redux';

export const getCons = (state: IApplicationState): string => {
  return pathOr('', ['newReview', 'data', 'cons', 'value'], state);
};
